const HoverColumn = ({ colDef }) => {
  return <div title={colDef.headerName}>{colDef.headerName}</div>;
};

export default HoverColumn;
